export default "__VITE_ASSET__CkhY228Z__"